import React, { useId } from "react";
import { twMerge } from "tailwind-merge";
import isSafari from "../../util/isSafari";
import cn from "classnames";
export const InputBase = React.forwardRef((props, ref) => {
    const { children, className, errorText, isError: isErrorProp, trailing: trailingProp, icon, small, style, disabled, errorClassName, dataCySuffix, data1pIgnore = true, ...inputProps } = props;
    const trailing = icon != null
        ? {
            node: icon,
            width: 48,
        }
        : trailingProp;
    const isError = isErrorProp || (errorText != null && errorText.length > 0);
    const errorTextId = useId();
    const dataCy = dataCySuffix ? `ukt-input-${dataCySuffix}` : "ukt-input";
    return (React.createElement("div", { className: "relative" },
        React.createElement("div", null,
            React.createElement("input", { disabled: disabled, ref: ref, "data-cy": dataCy, "aria-invalid": isError ? "true" : "false", "aria-errormessage": isError ? errorTextId : undefined, className: twMerge("ukt-input", `typography-main
              box-border  h-12
              w-full min-w-[1px] flex-grow 
              resize-none rounded-[10px] 
              border border-solid
              border-separator-color bg-input-bg-color px-4
              shadow-input_inner placeholder:text-placeholder-color 
              `, !isError &&
                    "focus:border-program-credit-color focus:shadow-none  focus:outline focus:outline-1 focus:outline-program-credit-color", small && "min-h-8 max-h-8 rounded-[5px] py-[10px]", isError &&
                    "border-delete-color !shadow-none outline-delete-color focus:shadow-none focus:outline ", disabled && "cursor-not-allowed opacity-80", isSafari() && "focus:!outline-none", className), style: {
                    ...style,
                    paddingRight: trailing?.width,
                }, onClick: disabled ? () => { } : inputProps.onClick, ...inputProps, "data-1p-ignore": data1pIgnore ? "true" : undefined }),
            trailing && (React.createElement("div", { className: "absolute top-0 bottom-0 right-0 flex items-center justify-center", style: { width: trailing.width } }, trailing.node))),
        React.createElement(InputError, { id: errorTextId, className: errorClassName }, errorText)));
});
export const InputError = (props) => {
    return (React.createElement("span", { id: props.id, className: cn("typography-small absolute left-4 text-delete-color", !props.children && "hidden", props.className), role: "alert" }, props.children));
};
//# sourceMappingURL=InputBase.js.map